const PENDING_REGISTRATION_KEY = 'pending_registration';
const HAD_SUCCESS_LOGIN_KEY = 'had_success_login';

export function setPendingRegistration(email: string, userId?: string): void {
  if (typeof window !== 'undefined') {
    const data = JSON.stringify({ email, userId });
    localStorage.setItem(PENDING_REGISTRATION_KEY, data);
  }
}

export function getPendingRegistration(userId?: string): string | null {
  if (typeof window !== 'undefined') {
    const data = localStorage.getItem(PENDING_REGISTRATION_KEY);
    if (data) {
      try {
        const parsedData = JSON.parse(data) as { email: string; userId: string };

        if (userId === parsedData.userId) {
          clearPendingRegistration();
          return parsedData.email;
        }

        return null;
      } catch {
        return null;
      }
    }
  }
  return null;
}

export function getPendingRegistrationEmail(): string {
  if (typeof window === 'undefined') {
    return '';
  }

  try {
    const data = localStorage.getItem(PENDING_REGISTRATION_KEY);

    if (!data) {
      return '';
    }

    const parsedData = JSON.parse(data) as { email?: string };
    return parsedData.email?.trim() ?? '';
  } catch {
    return '';
  }
}

export function clearPendingRegistration(): void {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(PENDING_REGISTRATION_KEY);
  }
}

export function setHadSuccessLogin(): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem(HAD_SUCCESS_LOGIN_KEY, 'true');
  }
}

export function hadSuccessLogin(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return localStorage.getItem(HAD_SUCCESS_LOGIN_KEY) === 'true';
}
